// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"Loading_lds-dual-ring__vhib2"};